import React from "react";
import { Flex, Text, LoadingIndicator } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import {
  messageLoadingIndicator,
  messageLoadingHeader,
  messageThinkingBody,
} from "./styles_vanilla.css";

export type MessageLoadingIndicatorProps = {
  thinkingText?: string;
};

export const MessageLoadingIndicator: React.FC<MessageLoadingIndicatorProps> = ({
  thinkingText,
}) => {
  return (
    <Flex
      flexDirection="column"
      gap={Sizes.SM}
      className={messageLoadingIndicator}
      data-testid="message-loading"
    >
      <Flex alignItems="center" gap={Sizes.SM}>
        <LoadingIndicator data-testid="message-loading-spinner" />
        <Text
          variant="secondary-md"
          className={messageLoadingHeader}
          data-testid="message-loading-text"
        >
          Thinking...
        </Text>
      </Flex>
      {thinkingText && (
        <div className={messageThinkingBody} data-testid="message-thinking-body">
          <Text variant="secondary-md">{thinkingText}</Text>
        </div>
      )}
    </Flex>
  );
};
